var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CheckboxIcon',{attrs:{"checked":_vm.value,"size":_vm.size},nativeOn:{"click":function($event){return _vm.toggle.apply(null, arguments)}}})}
var staticRenderFns = []

export { render, staticRenderFns }